// Require the custom Modernizr build, which adds itself to window.
require('@temp/js/modernizr-custom');

const Modernizr = window.Modernizr;

/**
 * Check if this browser supports ProPoint.
 * Remember, this code has to be fairly old-fashioned, as anything too modern will defeat its purpose!
 * ^ Not true anymore because this is run through Babel so we can go wild.
 *
 * Modernizr has both synchronous and asynchronous tests which need to be handled differently
 *
 * @var {Modernizr} Modernizr
 */

const syncTests = [
    'arrow',
    'promises',
];

const asyncTests = [
    // 'indexeddb'
];

/**
 * @param {string} feature The name of the feature to test for. Note: You will need the non-namespaced version of what
 * is defined in modernizr-config.json. Eg. "es6/arrow" becomes "arrow".
 */
function checkSyncTest(feature) {
    if (Modernizr.hasOwnProperty(feature)) {
        // Unfortunately, the Modernizr global object can contain a mixture of boolean primitives and Boolean objects
        if (
            (typeof Modernizr[feature] === 'boolean' && Modernizr[feature] === true)
            || (Modernizr[feature] instanceof Boolean && Modernizr[feature].valueOf() === true)
        ) {
            return true;
        }
    }

    return false;
}

function showUnsupportedMessage() {
    // Empty the entire body so that our application cannot start up properly, and replace with our message
    document.body.innerHTML = `
        <div class="simple-browser-message">
            <div class="simple-browser-message__container">
                <div class="alert alert-danger" role="alert">
                    <h3>
                        <i class="fa-solid fa-exclamation-triangle"></i>
                        Warning
                    </h3>

                    <div class="text-left">
                        <h4 class="mb-1">You appear to be running a web browser which is incompatible with ProPoint</h4>
                        <p><strong>Please update your browser before continuing.</strong>
                        <p>ProPoint requires one of the following:</p>
                        <ul>
                            <li>
                                <strong>Windows</strong>: latest version of Firefox
                                <br /><strong><em>(Not running in Private Mode and with Remember history enabled)</em></strong>
                            </li>
                            <li>
                                <strong>Windows</strong>: latest version of Chrome
                                <br /><strong><em>(Not running in Incognito Mode)</em></strong>
                            </li>
                            <li>
                                <strong>Android</strong>: latest version of Chrome
                                <br /><strong><em>(Not running in Incognito Mode)</em></strong>
                            </li>
                        </ul>
                        <p><small>Please note: the operating system version must be currently supported and receiving security updates.</small></p>
                    </div>
                </div>
            </div>
        </div>`;
}

// Check any synchronous tests
syncTests.forEach((testName) => {
    const result = checkSyncTest(testName);
    console.log('Modernizr: ', testName + ' result: ', result);
    if (!result) {
        showUnsupportedMessage();
    }
});

let failedTests = 0;
let testsRun = 0;

// Watch for results from asynchronous tests
asyncTests.map((testName) => Modernizr.on(testName, (result) => {
    console.log('Modernizr: ', testName + ' result: ', result);
    if (!result) {
        failedTests++;
    }
    testsRun++;
    if (testsRun === asyncTests.length && failedTests > 0) {
        showUnsupportedMessage();
    }
}));
